const States = {"Normal":1, "Hover":2, "P1Block":3, "P2Block": 4}
Object.freeze(States)
const types = {"HEDGE": 1, "VEDGE": 2, "SLOT": 3, "CROSS": 4}
Object.freeze(types)

function isEmptyState(state) {
    return state == States.Normal || state == States.Hover;
}

class GridElement {
    // constructor
    constructor(idname, etype) {
        this.id = idname;
        this.state = States.Normal;
        this.type = etype;
    }

    getEdge() {
        if (this.type !== types.HEDGE && this.type != types.VEDGE) {
            return null;
        }
        let vertexs = this.id.split('-');
        vertexs[0] = parseInt(vertexs[0]);
        vertexs[1] = parseInt(vertexs[1]);
        return vertexs;
    }
}

class Grid {

    constructor(width, height, walls, numberOfPeaches, peachesToWin) {
        this.width = width;
        this.height = height;
        this.numberOfPeaches = numberOfPeaches;
        this.peachesToWin = peachesToWin;
        // one the top
        this.monkeyKingPosition = [0, Math.trunc(this.width/2)];

        this.allWalls = walls;
        // remain walls
        this.remainWalls = walls;

        this.step = 0;
        this.monkeyKingWin = false;
        this.monkeyKingLegalMoves = [];
        this.peachesPosition = [];

        this.edges = new Map();

        for(var i = 0; i < numberOfPeaches; i++){
            var h = Math.round(Math.random()*(height-1));
            var w = Math.round(Math.random()*(width-1));
            if((h == this.monkeyKingPosition[0] && w == this.monkeyKingPosition[1]) || (this.peachesPosition.includes(h+"-"+w))){
                i -= 1;
                continue;
            }else{
                this.peachesPosition.push(h+"-"+w);
            }
        }

        this.gridIDS = [];
        for (var row = 0; row < height; row++) {
            var horizGids = [];
            for (var col = 0; col < width; col++) {
                let corssElem = new GridElement('', types.CROSS);
                horizGids.push(corssElem);
                let elemElem = new GridElement('', types.HEDGE);
                horizGids.push(elemElem);
                if (col == width-1) {
                    let corssElem = new GridElement('', types.CROSS);
                    horizGids.push(corssElem);
                }
            }
            this.gridIDS.push(horizGids) 

            // vertical
            var verticalGids = [];
            for ( col = 0; col < width; col++) {
                let currID = this.getID(row, col);
                // let rightID = this.getID(row, col+1);
                let edgeElem = new GridElement('', types.VEDGE);
                verticalGids.push(edgeElem)

                let slotElem = new GridElement(currID.toString(), types.SLOT);
                verticalGids.push(slotElem)
                if (col == width-1) {
                    let edgeElem = new GridElement('', types.VEDGE);
                    verticalGids.push(edgeElem)
                }
            }
            this.gridIDS.push(verticalGids)
            if (row == height-1) {
                var lastHorizGids = [];
                for (col = 0; col < width; col++) {
                    let corssElem = new GridElement('', types.CROSS);
                    lastHorizGids.push(corssElem);
                    let elemElem = new GridElement('', types.HEDGE);
                    lastHorizGids.push(elemElem);
                    if (col == width-1) {
                        let corssElem = new GridElement('', types.CROSS);
                        lastHorizGids.push(corssElem);
                    }
                }
                this.gridIDS.push(lastHorizGids) 
            }
        }
    }

    resetGame(){
        this.remainWalls = this.allWalls;
        this.edges = new Map;
    }
    removePeach(row,col){
        var index = this.peachesPosition.indexOf(row+"-"+col);
        if (index > -1) {
            this.peachesPosition.splice(index, 1);
        }
    }

    isPeachInGrid(iidx,jidx){
        if (this.gridIDS[iidx][jidx].type !== types.SLOT) {
            return false;
        }
        let row = Math.trunc(iidx/2);
        let col = Math.trunc(jidx/2);
        return this.isPeach(row,col);
    }
    
    isPeach(row,col){
        return this.peachesPosition.includes(row+"-"+col);
    }

    resetWalls(){
        this.remainWalls = this.allWalls;
        this.edges = new Map;
    }

    putEdges(idx, jidx){
        if(this.edges[idx+'-'+jidx] === undefined){
            this.edges[idx+'-'+jidx] = 1;
        }else{
            this.edges[idx+'-'+jidx] = this.edges[idx+'-'+jidx]+1;
        }
       
    }

    getID(row, col) {
        return row * this.width + col
    }

    canPutOnGridElement(iidx, jidx) {
        let gridElem = this.gridIDS[iidx][jidx];
        if (gridElem.type !== types.VEDGE && gridElem.type !== types.HEDGE) {
            return false
        }
        if (!isEmptyState(gridElem.state)) {
            return false
        }       
        return true
    }

    setNext3Edge(iidx, jidx, state) {
        this.gridIDS[iidx][jidx].state = state; 
    }



    isPlayer1InGrid(iidx, jidx) {
        if (this.gridIDS[iidx][jidx].type !== types.SLOT) {
            return false;
        }
        let row = Math.trunc(iidx/2);
        let col = Math.trunc(jidx/2);
        return this.monkeyKingPosition[0] == row && this.monkeyKingPosition[1] == col;
    }

    isRowColValid(row, col) {
        if (row < 0 || row >= this.height || col < 0 || col >= this.width) {
            return false;
        }
        return true;
    }

    clearLegalMoves() {
        this.monkeyKingLegalMoves = [];
    }


    moveMonkeyKing(row, col,idx, jidx) {
        if(row == this.monkeyKingPosition[0] && col == this.monkeyKingPosition[1]){
            return false;
        }
        if(row == this.monkeyKingPosition[0]){
            if(col!=this.monkeyKingPosition[1]-1 && col!=this.monkeyKingPosition[1]+1){
                return false;
            }
        }else if(col == this.monkeyKingPosition[1]){
            if(row!=this.monkeyKingPosition[0]-1 && row!=this.monkeyKingPosition[0]+1){
                return false;
            }
        }else{
            return false;
        }
        this.step += 1;
        var rowDif = this.monkeyKingPosition[0] - row;
        var colDif = this.monkeyKingPosition[1] - col;
        var key = (idx+rowDif)+"-"+(jidx+colDif);

        if(this.edges[key]!==undefined && this.edges[key] > 0){
            this.edges[key] = this.edges[key]-1;
            return;
        }
        this.monkeyKingPosition = [row, col];
        if(this.isPeach(row,col)){
            this.removePeach(row,col);
            this.peachesToWin -= 1;
            this.resetWalls();
            return !(this.peachesToWin==0);
        }
        return false;
    }


}

export {
    Grid, States, types
}